import React from 'react';
import PointApprovalManagement from './PointApprovalManagement';

const PointApprovalManagementTax: React.FC = () => {
  return <PointApprovalManagement period="tax" />;
};

export default PointApprovalManagementTax;
